import { render, staticRenderFns } from "./select-lang.vue?vue&type=template&id=08273db3&scoped=true&"
import script from "./select-lang.vue?vue&type=script&lang=ts&"
export * from "./select-lang.vue?vue&type=script&lang=ts&"
import style0 from "./select-lang.vue?vue&type=style&index=0&id=08273db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08273db3",
  null
  
)

export default component.exports